/* eslint-disable no-nested-ternary */
import classNames from 'classnames'
import toLower from 'lodash/toLower'
import { Link } from 'react-router-dom'

import DashboardBarChart from './DashboardBarChart'
import DashboardPieChart from './DashboardPieChart'

import DateTime from 'admin/components/common/DateTime'
import PageFrame from 'admin/components/common/PageFrame'
import Text from 'admin/components/common/Text'
import { withContext } from 'admin/components/common/withContext'
import { DashboardState, InvoiceCountState } from 'admin/redux/ducks/dashboard'
import { LoginState } from 'admin/redux/ducks/login'
import { OrgAccountState } from 'admin/redux/ducks/orgAccount'
import Price from 'ansok/components/common/Price'
import { maxPurchaseLimitsForDifferentRiskLevelsOnApplication, RiskLevel } from 'ansok/types'
import { ApartmentIcon } from 'components/ui/Icons'
import Loader from 'components/ui/Loader'


const DashboardView: React.FC<DashboardViewProps> = ({
  dashboard,
  login,
  invoiceCount,
  navigateTo,
  organization,
}) => {
  const { paymentPurchasers,transactionStats } = dashboard || {}
  let invoicedCount = 0
  let collectionAndReminderCount = 0
  if (invoiceCount.data) {
    if (
      invoiceCount.data.invoiceCount.collection +
        invoiceCount.data.invoiceCount.reminder >
      0
    ) {
      collectionAndReminderCount =
        invoiceCount.data.invoiceCount.collection +
        invoiceCount.data.invoiceCount.reminder
    } else if (invoiceCount.data.invoiceCount.invoiced > 0) {
      invoicedCount = invoiceCount.data.invoiceCount.invoiced
    }
  }
  return (
    <PageFrame windowTitle={login.data.orgName}>
      <div className="Dashboard">
        <DashboardCell type="info" width={2}>
          <div className="Dashboard__cell__image-holder">
            <ApartmentIcon />
          </div>
          <h1>
            <Link to="/organisation" className="link--hover">
              {login.data.orgName}
            </Link>
          </h1>
          <h1>
            <Link to="/orgkonto" className="link--hover">
              {login.data.orgAccountName}
            </Link>
          </h1>
        </DashboardCell>
        <DashboardCell type="info" onClick={() => window.open('https://www.coop.se/fakturatjanst/hjalp', '_blank')}>
          {paymentPurchasers.data && (
            <>
              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <h1>
                  <Text>general.help</Text>
                </h1>
              </div>
              <div>
                <h2>
                  <Text style={{ textDecoration: 'underline' }}>
                    label.to_help_page
                  </Text>
                </h2>
              </div>
            </>
          )}
        </DashboardCell>
        <DashboardCell
          type={paymentPurchasers.data ? 'primary' : 'info'}
          onClick={() => navigateTo('/kopare')}
        >
          {paymentPurchasers.data && (
            <>
              <h1>{paymentPurchasers.data.activeAccountCount}</h1>
              <h2>
                <Text
                  count={paymentPurchasers.data.activeAccountCount}
                  filters={toLower}
                >
                  general.active_buyer_count
                </Text>
              </h2>
              <button className="button--hollow button--white">
                <Text>general.handle</Text>
              </button>
            </>
          )}
          <Loader visible={paymentPurchasers.isLoading} local />
        </DashboardCell>
        <DashboardCell
          type={
            collectionAndReminderCount > 0
              ? 'error'
              : invoicedCount > 0
              ? 'warning'
              : 'primary'
          }
          onClick={
            collectionAndReminderCount + invoicedCount > 0
              ? () => navigateTo('/faktura')
              : null
          }
        >
          <>
            <h1>
              {invoiceCount.data
                ? collectionAndReminderCount > 0
                  ? collectionAndReminderCount
                  : invoicedCount
                : '?'}
            </h1>
            <h2>
              {collectionAndReminderCount > 0 ? (
                <Text count={collectionAndReminderCount} filters={toLower}>
                  general.delayed_invoices_count
                </Text>
              ) : (
                <Text count={invoicedCount} filters={toLower}>
                  general.unpaid_invoices_count
                </Text>
              )}
            </h2>
            {invoiceCount.data &&
              collectionAndReminderCount + invoicedCount > 0 && (
                <button className="button--hollow button--white">
                  <Text>general.show</Text>
                </button>
              )}
          </>
          <Loader
            visible={invoiceCount.isLoading || paymentPurchasers.isLoading}
            local
          />
        </DashboardCell>

        <DashboardCell
          type="graph"
          width={2}
          height={2}
          onClick={() => navigateTo('/kop')}
        >
          {transactionStats.data &&
          transactionStats.data.transactionMonthStats &&
          transactionStats.data.transactionMonthStats.count > 0 ? (
            // if stats and company risk >= 3
            organization.data?.effectivePurchaseLimit !== null &&
            organization.data?.effectivePurchaseLimit <=
              maxPurchaseLimitsForDifferentRiskLevelsOnApplication[RiskLevel.MEDIUM_RISK] ? (
              <>
                <div
                  style={{ display: 'flex', justifyContent: 'space-between' }}
                >
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <h2>
                      <Text>label.dashboard.purchases_current_month</Text>
                    </h2>
                    <h1>
                      <Price decimals={0}>
                        {organization.data.effectivePurchaseLimit -
                          organization.data.organizationAvailableAmount}
                      </Price>
                    </h1>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <h2>
                      <Text>label.dashboard.remaining_purchase_amount</Text>
                    </h2>
                    <h1>
                      <Price
                        decimals={0}
                        style={
                          organization.data.organizationAvailableAmount < 1000
                            ? { color: 'red' }
                            : { color: 'rgb(0, 170, 70)' }
                        }
                      >
                        {organization.data.organizationAvailableAmount}
                      </Price>
                    </h1>
                  </div>
                </div>

                <button className="button--hollow">
                  <Text>general.show</Text>
                </button>
                <DashboardBarChart
                  className="l-height--9 l-margin--t"
                  stats={transactionStats.data.transactionMonthStats}
                  axisComponent={DashboardBarChartAxisLabel}
                  tooltipComponent={DashboardBarTooltipLabel}
                  labelComponent={DashboardBarChartMonthLabel}
                />
              </>
            ) : (
              // if stats but company risk < 3
              <>
                <h2>
                  <Text>label.dashboard.purchases_current_month</Text>
                </h2>
                <h1>
                  <Price decimals={0}>
                    {transactionStats.data.transactionMonthStats.last}
                  </Price>
                </h1>
                <button className="button--hollow">
                  <Text>general.show</Text>
                </button>
                <DashboardBarChart
                  className="l-height--9 l-margin--t"
                  stats={transactionStats.data.transactionMonthStats}
                  axisComponent={DashboardBarChartAxisLabel}
                  tooltipComponent={DashboardBarTooltipLabel}
                  labelComponent={DashboardBarChartMonthLabel}
                />
              </>
            )
          ) : (
            // if no stats for this month
            <div className="l-flex--centered-child">
              <h2>
                <Text>label.dashboard.no_purchases_current_month</Text>
              </h2>
            </div>
          )}
          <Loader visible={transactionStats.isLoading} local />
        </DashboardCell>

        <DashboardCell type="graph" width={2} height={100}>
          {transactionStats.data &&
          transactionStats.data.transactionRecipientStats &&
          transactionStats.data.transactionRecipientStats.count > 0 ? (
            <>
              <h2>
                <Text>label.dashboard.purchases_per_invoice_recipient</Text>
              </h2>
              <DashboardPieChart
                stats={transactionStats.data.transactionRecipientStats}
                tooltipComponent={DashboardPieTooltipLabel}
              />
            </>
          ) : (
            <div className="l-flex--centered-child">
              <h2>
                <Text>label.dashboard.no_purchases_per_invoice_recipient</Text>
              </h2>
            </div>
          )}
          <Loader visible={transactionStats.isLoading} local />
        </DashboardCell>
      </div>
    </PageFrame>
  )
}

export type DashboardViewProps = {
  login: LoginState
  dashboard: DashboardState
  navigateTo: (location) => void
  invoiceCount: InvoiceCountState
  organization?: OrgAccountState
}

const DashboardCell: React.FunctionComponent<DashboardGridCellProps> = (
  props: DashboardGridCellProps
) => {
  const { type, width, height, className, onClick, children, ...otherProps } =
    props
  const classes = classNames(
    'Dashboard__cell',
    type ? `Dashboard__cell--type-${type}` : null,
    width > 1 && `Dashboard__cell--width-${width}`,
    height > 1 && `Dashboard__cell--height-${height}`,
    onClick && 'u-clickable',
    className
  )
  return (
    <div className={classes} onClick={onClick} {...otherProps}>
      {children}
    </div>
  )
}

DashboardCell.defaultProps = {
  width: 1,
  height: 1,
}

type DashboardGridCellProps = {
  type?: 'info' | 'primary' | 'error' | 'graph' | 'warning'
  width?: number
  height?: number
  className?: string
  onClick?: () => any
  children: React.ReactNode
}

const DashboardPieTooltipLabel: React.FunctionComponent<any> = (props) => {
  const { item, ...otherProps } = props
  return (
    <span {...otherProps}>
      {item.label}
      <br />
      {(item.value * 100).toFixed(1)}%
    </span>
  )
}

const DashboardBarChartAxisLabel: React.FunctionComponent<any> = (props) => {
  const { children, className, ...otherProps } = props
  return (
    <Price
      rounded
      className={classNames('u-ghosted', className)}
      {...otherProps}
    >
      {children}
    </Price>
  )
}

const DashboardBarTooltipLabel: React.FunctionComponent<any> = (props) => {
  const { item, ...otherProps } = props
  return (
    <span {...otherProps}>
      <DateTime format="MMM YYYY">{item.label}</DateTime>
      <br />
      <Price>{item.value}</Price>
    </span>
  )
}

const DashboardBarChartMonthLabel: React.FunctionComponent<any> = (props) => {
  const { children, ...otherProps } = props
  return (
    <DateTime format="MMM" {...otherProps}>
      {children}
    </DateTime>
  )
}

export default (withContext(DashboardView))
